import React from 'react';


export default (props) => {
	if (props.iff)
		return <>{props.children}</>;
	return <></>;
}